class TestPreparationComponent {
    constructor(AppServiceApi, $routeParams) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            const simId = parseInt(this.routeParamService.simId, 10);
            const abstractTesterId = parseInt(this.routeParamService.abstractTesterId, 10);
            const dynamicUrlPart = abstractTesterId ? `${simId}/${abstractTesterId}` : `${simId}`;
            this.rufUrl = `RUF/simulator/${dynamicUrlPart}/test-preparation?embed=true`;
            this.AppServiceApi.settings().then((response) => {
                this.responseAppSettings = response.data;
                this.enableRUF = this.responseAppSettings.EnableRUF && this.responseAppSettings.EnableRUFComponents.some(c => c.toLowerCase() === 'testcasedesign');
            });
        };
        this.AppServiceApi = AppServiceApi;
        this.routeParamService = $routeParams;
    }
}
angular.module('app').component('testPreparation', {
    bindings: {},
    templateUrl: 'scripts/app/partials/TestPreparation/test-preparation.tpl.html',
    controllerAs: 'vm',
    controller: TestPreparationComponent
});
